import { render } from "./SelectManufactorWrapper.vue?vue&type=template&id=3a9159de"
import script from "./SelectManufactorWrapper.vue?vue&type=script&lang=js"
export * from "./SelectManufactorWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__